/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

// AUTOGENERATED BY glean_parser v19.0.0. DO NOT EDIT. DO NOT COMMIT.

import EventMetricType from '@mozilla/glean/private/metrics/event';

/**
 * Engagement with checkboxes on step 1 of account deletion funnel page
 *
 * Generated from `delete_account.engage`.
 */
export const engage = new EventMetricType(
  {
    category: 'delete_account',
    name: 'engage',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  []
);

/**
 * Click on the submit button of step 2 of the account deletion funnel
 *
 * Generated from `delete_account.password_submit`.
 */
export const passwordSubmit = new EventMetricType(
  {
    category: 'delete_account',
    name: 'password_submit',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  []
);

/**
 * View of step 2 of the account deletion funnel (view of password form)
 *
 * Generated from `delete_account.password_view`.
 */
export const passwordView = new EventMetricType(
  {
    category: 'delete_account',
    name: 'password_view',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  []
);

/**
 * Click on the "Delete Account" button on account settings page
 *
 * Generated from `delete_account.settings_submit`.
 */
export const settingsSubmit = new EventMetricType(
  {
    category: 'delete_account',
    name: 'settings_submit',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  []
);

/**
 * Click on the "Continue" button on step 1 of the delete account funnel
 *
 * Generated from `delete_account.submit`.
 */
export const submit = new EventMetricType(
  {
    category: 'delete_account',
    name: 'submit',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  []
);

/**
 * View of step 1 of the account deletion funnel page
 *
 * Generated from `delete_account.view`.
 */
export const view = new EventMetricType(
  {
    category: 'delete_account',
    name: 'view',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  []
);
